'use client';

import { RETENTION_DESKTOP_MIN_WIDTH } from '@/components/Form/CancellationRetention/cancellationRetentionHelper';
import { useLayoutEffect, useState } from 'react';

const DESKTOP_MEDIA_QUERY = `(min-width: ${RETENTION_DESKTOP_MIN_WIDTH}px)`;

export function useCancellationRetentionViewport(): {
  isDesktop: boolean;
  isReady: boolean;
} {
  const [viewport, setViewport] = useState<{ isDesktop: boolean } | null>(null);

  useLayoutEffect(() => {
    const mediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);

    const syncViewport = () => {
      setViewport({ isDesktop: mediaQuery.matches });
    };

    syncViewport();
    mediaQuery.addEventListener('change', syncViewport);

    return () => {
      mediaQuery.removeEventListener('change', syncViewport);
    };
  }, []);

  return {
    isDesktop: viewport?.isDesktop ?? false,
    isReady: viewport !== null,
  };
}
